import { render, staticRenderFns } from "./MsalespeopleCreate.vue?vue&type=template&id=050f47df&scoped=true"
import script from "./MsalespeopleCreate.vue?vue&type=script&lang=js"
export * from "./MsalespeopleCreate.vue?vue&type=script&lang=js"
import style0 from "./MsalespeopleCreate.vue?vue&type=style&index=0&id=050f47df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f47df",
  null
  
)

export default component.exports